import { Component, Input } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
    selector: 'app-conv-blinks-heatmap',
    templateUrl: './conv-blinks-heatmap.component.html',
    styleUrl: './conv-blinks-heatmap.component.scss',
    standalone: false
})
export class ConvBlinksHeatmapComponent {
  @Input() data: any[] = [];

  chartData: any[] = [];

	ready = false;
  legend = false;
	animations = false;
	xAxis = true;
	yAxis = true;
	showYAxisLabel = true;
	showXAxisLabel = true;
	min = 0;
	max = 3;
	colorScheme: string | Color = {
		name: 'myScheme',
		selectable: true,
		group: ScaleType.Ordinal,
		domain: ['transparent', '#15A607', '#F1D50A', '#F1960A', '#F11C0A'],
	};

  lastls = 0; // eyeBlinkLeft_short
	lastll = 0; // eyeBlinkLeft_long
	lastlc = 0; // eyeCloseLeft
	lastrs = 0; // eyeBlinkRight_short
	lastrl = 0; // eyeBlinkRight_long
	lastrc = 0; // eyeCloseRight
	
  showHeatmap() {
		this.ready = true;
		this.calculateHeatMapData(20);
	}

  calculateHeatMapData(currentTime: number) {
		const start = currentTime - 20;
		const dataChart = [];

		for (let index = start; index <= currentTime; index++) {
			const time = this.convertToTimerFormat(index);

			let ls;
			let ll;
			let lc;
			let rs;
			let rl;
			let rc;

			if (index < this.data.length) {
				ls = this.data[index]['eyeBlinkLeft_short'];
				ll = this.data[index]['eyeBlinkLeft_long'];
				lc = this.data[index]['eyeCloseLeft'];
				rs = this.data[index]['eyeBlinkRight_short'];
				rl = this.data[index]['eyeBlinkRight_long'];
				rc = this.data[index]['eyeCloseRight'];

				this.lastls = ls;
				this.lastll = ll;
				this.lastlc = lc;
				this.lastrs = rs;
				this.lastrl = rl;
				this.lastrc = rc;
			} else {
				ls = this.lastls;
				ll = this.lastll;
				lc = this.lastlc;
				rs = this.lastrs;
				rl = this.lastrl;
				rc = this.lastrc;
			}

			let data = {};

			data = {
				name: time,
				series: [
					{ name: 'Left Eye Blink Short', value: ls, original: ls },
					{ name: 'Left Eye Blink Long', value: ll, original: ll },
					{ name: 'Left Eye Close', value: lc, original: lc },
					{ name: 'Right Eye Blink Short', value: rs, original: rs },
					{ name: 'Right Eye Blink Long', value: rl, original: rl },
					{ name: 'Right Eye Close', value: rc, original: rc }
				]
			};

			dataChart.push(data);
		}

		this.chartData = [...dataChart];

		if (!this.ready) {
			this.ready = true;
		}
	}

  tooltipText(data: any): string {
		const cell = JSON.parse(JSON.stringify(data)).cell;

		let spanContent;

		if (Array.isArray(cell.original)) {
			const listItems = cell.original.map((item: any) => `<li>${item}</li>`).join('');
			spanContent = `<ol>${listItems}</ol>`;
		} else {
			spanContent = cell.original;
		}

		const span = `<span>${spanContent}</span>`;

		const tool = `
			<div class="p-1 fs-16">
				${cell.series} - ${cell.name}
				<hr class="m-0">
				${span}
			</div>
		`;

		return tool;
	}

	updateHeatmap(currentTime: number) {
		if (currentTime > 20) {
			this.calculateHeatMapData(currentTime);
		} else {
			this.calculateHeatMapData(20);
		}
	}

	convertToTimerFormat(seconds: number) {
		if (seconds < 3600) {
			// Display "mm:ss" format for the first 60 minutes
			const minutes = Math.floor(seconds / 60);
			const formattedSeconds = (seconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			return `${formattedMinutes}:${formattedSeconds}`;
		} else {
			// After 60 minutes, switch to "hh:mm:ss" format
			const hours = Math.floor(seconds / 3600);
			const remainingSeconds = seconds % 3600;
			const minutes = Math.floor(remainingSeconds / 60);
			const formattedSeconds = (remainingSeconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			const formattedHours = hours.toString().padStart(2, "0");
			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		}
	}
}
